import { log } from './log'

export const logVersion = () => {
  log('Version', process.env.VERSION)
  log('SHA', process.env.SHA)
}
